import { render, staticRenderFns } from "./manage-kpi.vue?vue&type=template&id=ea21e270"
import script from "./manage-kpi.vue?vue&type=script&lang=js"
export * from "./manage-kpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports